import type { ProblemReportContext } from '../../api/generated/model/problemReportContext'
import { useLocaleStore } from '../../store/locale'
import { reportRouteName } from './registry'

interface Environment {
  userAgent: string
  locale: string
  timezone: string
  width: number
  height: number
  online: boolean
}
const browsers: ReadonlyArray<readonly [string, RegExp]> = [
  ['Edge', /Edg\/(\d+)/], ['Opera', /OPR\/(\d+)/], ['Firefox', /(?:Firefox|FxiOS)\/(\d+)/],
  ['Chrome', /(?:Chrome|CriOS)\/(\d+)/], ['Safari', /Version\/(\d+).*Safari\//],
]
function browser(userAgent: string) {
  for (const [family, pattern] of browsers) {
    const match = pattern.exec(userAgent)
    if (match && Number(match[1]) <= 999) return { family, major: Number(match[1]) }
  }
  return null
}
function timezone(value: string) {
  try {
    if (value.length > 64 || !/^[A-Za-z_]+(?:\/[A-Za-z0-9_+-]+)*$/.test(value)) return null
    return new Intl.DateTimeFormat('en', { timeZone: value }).resolvedOptions().timeZone
  } catch { return null }
}
export function problemReportMetadata(routeId: string, environment: Environment = {
  userAgent: navigator.userAgent,
  locale: useLocaleStore.getState().locale,
  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  width: window.innerWidth,
  height: window.innerHeight,
  online: navigator.onLine,
}): { route_name: string; frontend_release: null; context: ProblemReportContext } {
  const validDimension = (value: number) => Number.isInteger(value) && value > 0 && value <= 100_000
  return {
    route_name: reportRouteName(routeId), frontend_release: null,
    context: {
      browser: browser(environment.userAgent),
      locale: environment.locale === 'en' || environment.locale === 'tr' ? environment.locale : null,
      timezone: timezone(environment.timezone),
      viewport: validDimension(environment.width) && validDimension(environment.height) ? { width: environment.width, height: environment.height } : null,
      online: environment.online,
    },
  }
}
